import { Select, MenuItem, makeStyles } from '@material-ui/core';

import { DefaultCommandProps } from './index';

export interface SelectMenuProps extends DefaultCommandProps {
  options: string[];
}

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
  },
}));

const SelectMenu = ({ options, value, onChange, label }: SelectMenuProps) => {
  const classes = useStyles();

  return (
    <Select
      className={classes.input}
      id="select"
      labelId="select-label"
      onChange={(e) => onChange(label, e.target.value as string)}
      value={value}
    >
      {options.map((command) => (
        <MenuItem key={command} value={command}>
          {command}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectMenu;
